import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';
import ErrorField from '../ErrorField';
import LabelField from '../LabelField';
import css from '../SetBudget.module.css';

const DateRange = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  startDateError,
  endDateError,
}) => {
  return (
    <>
      <LabelField>Start Date</LabelField>
      {startDateError && <ErrorField>{startDateError}</ErrorField>}
      <div className={css.dateContainer}>
        <DatePicker
          locale="en"
          className={css.inputDate}
          popperClassName={css.popperDatepicker}
          dayClassName={() => css.dayDatepicker}
          placeholderText="Select The Start Date"
          dateFormat="d MMMM yyyy"
          onChange={onStartDateChange}
          selected={(startDate && new Date(startDate)) || ''}
          maxDate={(endDate && new Date(endDate)) || null}
        />
      </div>

      <LabelField>End Date</LabelField>
      {endDateError && <ErrorField>{endDateError}</ErrorField>}
      <div className={css.dateContainer}>
        <DatePicker
          locale="en"
          className={css.inputDate}
          popperClassName={css.popperDatepicker}
          dayClassName={() => css.dayDatepicker}
          placeholderText="Select The End Date"
          dateFormat="d MMMM yyyy"
          onChange={onEndDateChange}
          selected={(endDate && new Date(endDate)) || ''}
          minDate={(startDate && new Date(startDate)) || null}
        />
      </div>
    </>
  );
};

DateRange.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  startDateError: PropTypes.string.isRequired,
  endDateError: PropTypes.string.isRequired,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
};

export default React.memo(DateRange);
